export enum PhoneTypeEnum {
    Home = "Home",
    Mobile = "Mobile",
    Work = "Work",
    Facility = "Facility",
    Office = "Office"
}